import dashboard from './back/dashboard';
import auth from './back/auth';
import services from './back/services';
import packages from './back/packages';
import billing_cycles from './back/billing-cycles';
import user_admins from './back/user_admins';
import user_members from './back/user_members';
import user_registrars from './back/user_registrars';
import user_trainers from './back/user_trainers';
import subscriptions from './back/subscriptions';
import attendance from './back/attendance';
import activities from './back/activities';
import events from './back/events';
import account from './back/account';
import home from './front/index';
import schedule from './front/schedule';
import NotFound from './errors/notfound';

const routes = [
  auth,
  account,
  attendance,
  activities,
  dashboard,
  home,
  services,
  packages,
  user_admins,
  user_members,
  user_registrars,
  user_trainers,
  billing_cycles,
  subscriptions,
  events,
  schedule,
  {
    path: '/404',
    component: NotFound
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/pages/index.js